import { defineComponent as a, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "ef69496f-7b2d-4741-b956-b10936151a2c" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#ef69496f-7b2d-4741-b956-b10936151a2c)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h512v256l-265 45.2z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M210 256h302v256H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0v512l256-256L0 0z"
}, null, -1), x = { fill: "none" }, b = ["r"], W = /* @__PURE__ */ a({
  __name: "cz",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), c("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, h));
  }
});
export {
  W as default
};
//# sourceMappingURL=cz-968fb7e3.js.map
